/* eslint-disable */
import { call, put } from 'redux-saga/effects'
import { path } from 'ramda'
import PostDetailActions from '../Redux/PostDetails2Redux'


export const readPosts = function* readPosts(api, action) {
  try {
    const { options: { PostId, PostIds, GetLikes } } = action
    console.tron.display({
       name: 'readPosts',
       preview: 'details',
       value: {
         action: action,
         PostId: PostId,
         PostIds: PostIds,
         GetLikes: GetLikes,
       }
    })

    const newOptions = {
      PostId:   PostId,
      PostIds:  PostIds.join(','),
      GetLikes: GetLikes
    }

    // make the call to the api

    const response = yield call(api.getPostsDetail, newOptions)
/*
    console.tron.display({
       name: 'api getPostsDetail response',
       preview: 'expand',
       value: {
         response: response
       }
    })
*/
    if (response.ok) {

      // const { response } = action // catch: undefined is not an object (evaluating '_response.data')
      // const { data } = response
      // const apiResponse = data

      yield put(PostDetailActions.posts2Success(response))
    } else {
      yield put(PostDetailActions.posts2Failure(response))
    }
  }
  catch (e) {
    console.tron.display({
       name: 'readPosts error',
       preview: "expand",
       value: {
         message: e.message,
         e: e
       }
    })
  }
}
